import { shape, string, arrayOf } from 'prop-types';

export const dateRangeTypes = shape({
  type: string
});

export const filterOptionTypes = arrayOf(
  shape({
    key: string,
    values: arrayOf(string)
  })
);

export const sortByTypes = shape({
  field: string,
  order: string
});
